import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IRole } from 'src/app/models/IRole';
import { ITaxonomy, IUserDetails } from 'src/app/models/IUsersDetails';
import { configuration } from 'src/environments/environment';
import { PermissionMaster } from 'src/app/models/PermissionMaster';
import { ResetSecurityCode } from 'src/app/models/ResetSecurityCode';
import { BillingDetails, RenderingDetails } from 'src/app/models/BillingAndRendringDTO';
import { ClientFacility } from 'src/app/models/ClientFacility';

@Injectable({
  providedIn: 'root'
})
export class UserManagementService {

  constructor(private http: HttpClient) { }

  // Get roles by user Id
  getRoles(): Observable<IRole[]> {
    return this.http.get<IRole[]>(`${configuration.apiUrl + 'Admin/AllRoles'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  // Check user availability by user Id
  checkUserID(userId: string): Observable<void> {
    return this.http.get<void>(`${configuration.apiUrl + 'Admin/CheckUser'}?userid=${userId}&&clientid=${sessionStorage.getItem("FacilityId")}`)
  }

  // Add user
  addUserInfo(userDetailsInfo: IUserDetails): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(userDetailsInfo)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Admin/User'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Get the parent facility id and facility type for the current facility
  getFacilityParentDetails(facilityId: number): Observable<ClientFacility> {
    return this.http.get<ClientFacility>(`${configuration.apiUrl + 'Admin/FacilityParentDetails'}?facility=${facilityId}`);
  }

  // Check whether the given facility is a parent facility (i.e. one or more
  // other facilities reference it via ParentFacilityId)
  isParentFacility(facilityId: number): Observable<boolean> {
    return this.http.get<boolean>(`${configuration.apiUrl + 'Master/IsParentFacility'}?facility=${facilityId}`);
  }

  // Get a facility's users by role, without any location filter
  getUserDetailsByWithoutLocation(role: string, facilityId: number): Observable<IUserDetails[]> {
    return this.http.get<IUserDetails[]>(
      `${configuration.apiUrl + 'Admin/UserDetailsByRoleWoutLocation'}?roleid=${role}&&facility=${facilityId}`);
  }

  // Get all active and inactive users
  getAllUsers(): Observable<IUserDetails[]> {
    return this.http.get<IUserDetails[]>(`${configuration.apiUrl + 'Admin/ActiveInactive'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  // Get all active and inactive users
  getAllBillingProviderPayers(): Observable<IUserDetails[]> {
    return this.http.get<IUserDetails[]>(`${configuration.apiUrl + 'Admin/BillingProviderPayers'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  // Update user status by user Id
  updateUserStatus(userId: string, isActive: boolean, modified: string): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Admin/UserStatus'}?userId=${userId}&&isActive=${isActive}&&modifiedBy=${modified}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Get user details by user Id
  getUserInfoById(userId: string): Observable<IUserDetails> {
    var facilityId = 0;
    if(sessionStorage.getItem("lookupFacilityId") != null && sessionStorage.getItem("lookupFacilityId") != undefined && sessionStorage.getItem("lookupFacilityId") != ""){
      facilityId = Number(sessionStorage.getItem("lookupFacilityId"));
    }else{
      facilityId = Number(sessionStorage.getItem("FacilityId"));
    }
    
    return this.http.get<IUserDetails>(`${configuration.apiUrl + 'Admin/UserById'}?userid=${userId}&&facility=${facilityId}`);
  }

  // Get specific user details by user Id
  getUserInfoByIdForReset(userId: string): Observable<IUserDetails> {
    return this.http.get<IUserDetails>(`${configuration.apiUrl + 'Admin/ResetUserById'}?userid=${userId}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  // Update user details by user Id
  updateUserInfo(userDetailsInfo: IUserDetails): Observable<string> {
    userDetailsInfo.modifiedBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    const posteddata = {
      inputdata: JSON.stringify(userDetailsInfo)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Admin/UserInfo'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Update billing Providers Payers details by user Id
  updateBillingProviderPayersInfo(userDetailsInfo: IUserDetails): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(userDetailsInfo)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Admin/BillingProviderPayersInfo'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Reset password by user Id
  resetPassword(userDetailsInfo: IUserDetails): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Admin/ResetPassword'}`, userDetailsInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  //delete billing payer Info
  DeleteBillingProviderPayerInfo(Id: number, user: string): Observable<number> {
    return this.http.delete<number>(`${configuration.apiUrl + 'Admin/BillingProviderPayerInfo'}?id=${Id}&&user=${user}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Get all permissions
  getAllPermisiions(): Observable<PermissionMaster[]> {
    return this.http.get<PermissionMaster[]>(`${configuration.apiUrl + 'Admin/Permissions'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  // Update password by user Id
  updateUserLoginPassword(password: string): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Admin/UpdateLoginPassword'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&password=${encodeURIComponent(password).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  //Check Login details by UserId
  getLoginDetailsByUserId(password: string): Observable<IUserDetails> {
    return this.http.get<IUserDetails>(`${configuration.apiUrl + 'Admin/CheckLoginPassword'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&password=${password}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }
  updateProfileInfo(userDetailsInfo: IUserDetails): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(userDetailsInfo)
    }
    return this.http.put<string>(`${configuration.apiUrl + 'Admin/ProfileInfo'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  ResetSecurityCode(userDetailsInfo: ResetSecurityCode): Observable<string> {
    const signatureSizeImage = userDetailsInfo.signatureSizeImage;
    userDetailsInfo.signatureSizeImage = null;
    const posteddata = {
      inputdata: JSON.stringify(userDetailsInfo),
      signature: (signatureSizeImage)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Admin/ResetSecurityCode'}?facility=${sessionStorage.getItem("FacilityId")}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  //get users with Locations
  getAllUserswithLocations(): Observable<IUserDetails[]> {
    return this.http.get<IUserDetails[]>(`${configuration.apiUrl + 'Admin/UserWithLocations'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  //get Taxonomy
  getAllTaxonomy(): Observable<ITaxonomy[]> {
    return this.http.get<ITaxonomy[]>(`${configuration.apiUrl + 'Admin/GetTaxonomy'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  LoadallRendringProviderDetails(): Observable<RenderingDetails[]> {
    return this.http.get<RenderingDetails[]>(`${configuration.apiUrl + 'Admin/GetRenderProvider'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facilityId=${sessionStorage.getItem("FacilityId")}`)
  }
  
  InsertOrUpdateRenderProviderInfo(renderProviderInfo: RenderingDetails): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(renderProviderInfo)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Admin/InsertRenderProvider'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  DeleteRenderProvider(renderProvObj: RenderingDetails): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(renderProvObj)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Admin/DelRenderProv'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  LoadallBillingProviderDetails(Type:any): Observable<BillingDetails[]> {
    return this.http.get<BillingDetails[]>(`${configuration.apiUrl + 'Admin/GetBillingProvider'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facilityId=${sessionStorage.getItem("FacilityId")}&&Type=${Type}`)
  }

  InsertOrUpdateBillingProviderInfo(billingProviderInfo: BillingDetails): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(billingProviderInfo)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Admin/InsertBillingProvider'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  DeleteBillingProvider(billingProvObj: BillingDetails): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(billingProvObj)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Admin/DelBillingProv'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
}
